@let _media = media();
@switch (_media.dataType) {
  @case ('ImagePlaceableMedia') {
    <div class="image-placeable-media" [style.background-color]="convertLpColorToCSSColor(_media.color)">
      @let _url = _media.image?.url;
      @if (_url) {
        <app-visual-element class="image-placeable-media" [url]="_url" fit="cover" />
      }
    </div>
  }
  @case ('SolidColorPlaceableMedia') {
    <div
      class="solid-color-placeable-media"
      [style.background-color]="convertLpColorToCSSColor(_media.color)"
      style="width: 100%; height: 100%"
    ></div>
  }
  @case ('VideoPlaceableMedia') {
    <div class="video-placeable-media" [style.background-color]="convertLpColorToCSSColor(_media.color)">
      <video [src]="_media.video?.url" [loop]="_media.loop" style="width: 100%; height: 100%" autoplay (ended)="finished.emit()"></video>
    </div>
  }
}
